var map = {
	"./bmp": 593,
	"./bmp.js": 593,
	"./gif": 594,
	"./gif.js": 594,
	"./jpg": 595,
	"./jpg.js": 595,
	"./png": 596,
	"./png.js": 596,
	"./psd": 597,
	"./psd.js": 597,
	"./svg": 598,
	"./svg.js": 598,
	"./tiff": 599,
	"./tiff.js": 599,
	"./webp": 600,
	"./webp.js": 600
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 591
// module chunks = 1